import ConvertKit from '@widgets/ConvertKit';
import FavoriteShell from "../../../../content/posts/web-development/.how-to-switch-login-shell-on-mac-os/FavoriteShell";
import Tweet from "../../../../content/posts/Tweet";
import * as React from 'react';
export default {
  ConvertKit,
  FavoriteShell,
  Tweet,
  React
};